import React, {useState, useEffect} from "react";
import { Link, useLocation, useNavigate } from 'react-router-dom'
import {normalizeInput, normalizeDate, calculate_age} from '../functions';
import { Tooltip as ReactTooltip } from "react-tooltip";
import axios from "axios";
import {get_golfer_profile, updateMemberGolferProfile} from '../../API/APICalls';

export default function MembershipForm() {

    const navigate = useNavigate();
   
    const location = useLocation();
    let contact_guid = location.state.contact_guid;
    let golferData = [];
   
    const [inputs, setInputs] = useState({firstname: '', lastname: '', phone: '', email: '', dob: '', sex: '', address: '', address2:  '', city: '', state:'', zip: '', contact: ''});
   
    const handleChange = ({ target: { name, value } }: { target: { name: string, value: string } }) => setInputs(inputs => ({ ...inputs, [name]: value }));
    
    const [validate, setValidate] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [alert, setAlert] = useState('ms-2 alert alert-danger');
    const [message, setMessage] = useState('');

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setIsLoading(true);
       

        // //make call to API for create or update golfer
        const response = await updateMemberGolferProfile(inputs);

        // if (response)
        // {
         
        //     console.log(response);
            //setIsLoading(false);
        // }     

        setAlert('ms-2 alert alert-success');
        setMessage("Your profile has been successfulled updated!");
        
        setIsLoading(false);
      
      
      }

      
      const formatDob = (event:React.KeyboardEvent<HTMLInputElement>) => { 
          
        const result = normalizeDate(event.currentTarget.value)
      
       const age = calculate_age(result)
       setInputs({... inputs, "dob": result });

       if (age >= 13 && age <=100 && result.length >= 10) 
       {
          setValidate(false);
       } else {
          setValidate(true);
       }
               
    }

      const formatPhoneNumber = (event:React.KeyboardEvent<HTMLInputElement>) => { 
          
          const result = normalizeInput(event.currentTarget.value)
          setInputs({... inputs, "phone": result });
                  
      }

      const handleBlur = (event:React.ChangeEvent<HTMLInputElement>) => { 
   
      }

      useEffect(() => {
         setIsLoading(true);
         setAlert("");
         
         get_golfer_profile(contact_guid).then((response) => {

            golferData = JSON.parse(response || '').results[0].properties;
           
            setInputs({... inputs,  "firstname": golferData.firstname, "lastname": golferData.lastname, "phone": normalizeInput(golferData.phone), "email": golferData.email, "dob": golferData.date_of_birth, "sex": golferData.gender, "contact": golferData.contact_guid, "address": golferData.address, "address2": golferData.street_address_2 || '', "city": golferData.city || '', "state": golferData.hs_state_code, "zip": golferData.zip});
            setIsLoading(false);
        })

     }, []);



    return(
        <div className="container page_container mb-5 pb-5">
        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-10 mx-auto">
          <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 my-5"><h1 className="fs-1 text-left">Update Personal Info</h1></div>
            
            <form onSubmit={handleSubmit} name="Personal Information" autoComplete="off"> 
            
            {isLoading ? 
            <div className="loaderWrapper">
              <div className="loader"></div>
            </div>
            : ''}
            
            <div className="row col-sm-12 col-12 col-md-12 col-lg-12 col-xxl-12" >

                
                <div className={alert} role="alert">
                {message}
                </div>


                <div className="col-sm-6 pt-0 pb-2">
                  <label className="form-label">First Name*</label>
                  <input type="text" className="form-control" id="firstName" name="firstname" value={inputs.firstname || ''} onChange={handleChange} pattern="^[a-zA-Z\/'\-\s]+|[^@$^%*&#!]+^[^\x20-\x7F]$" placeholder="" required={true}/>
                  <div className="invalid-feedback">
                    Valid first name is required.
                  </div>
                </div>

                <div className="col-sm-6 pt-0 pb-2">
                  <label className="form-label">Last Name*</label>
                  <input type="text" className="form-control" id="lastname" name="lastname" value={inputs.lastname} onChange={handleChange} placeholder="" pattern="^[a-zA-Z\/'\-\s]+|[^@$^%*&#!]+^[^\x20-\x7F]$" required={true}/>
                  <div className="invalid-feedback">
                    Valid last name is required.
                  </div>
                </div>

                <div className="col-sm-12 mt-4">
                      <label className="form-label">Phone Number*</label>
                      <input type="text" pattern="[0-9\(\)\-\s]{14,14}" autoComplete="off" className="form-control" id="phone" name="phone" placeholder="" value={inputs.phone ||''} onChange={handleChange} onKeyUp={formatPhoneNumber}  minLength={14} maxLength={14}  required={true}/>
                      
                  </div>

                  <div className="col-sm-12 mt-4">
                      <label className="form-label">Email*</label>
                      <input type="email" className="form-control" id="email" name="email" placeholder="" value={inputs.email} onChange={handleChange} onBlur={handleBlur} disabled={true}/>
                      
                  </div>

                  <div className="col-12 col-sm-12 mt-3">
                      <div className="row">
                        <div className="col-5 col-sm-5 mt-4">
                          <label className="form-label">Date of Birth* <i className="bi bi-info-circle" data-tooltip-id="dob-tooltip"></i></label>
                          <input type="text" className="form-control" id="dob" placeholder="DD/MM/YYYY" name="dob" value={inputs.dob || ''} onChange={handleChange} onKeyUp={formatDob} minLength={6} maxLength={10} required={true}/>
                            <ReactTooltip
                              id="dob-tooltip"
                              place="top"
                              content="You must be at least 13 years old to join."
                            />
                            {validate ? 
                              <div className="fs-6 pt-2 text-danger ">
                                You must be at least 13 years or under 100 years old to join.
                              </div>
                              : ''}
                        </div>
                        <div className="col-6 col-sm-7 mt-4">
                          
                          <label className="form-label">Sex* <i className="bi bi-info-circle" data-tooltip-id="sex-tooltip"></i></label>
                          <ReactTooltip
                              id="sex-tooltip"
                              place="top"
                              content="Sex is used for applying proper Ratings for score posting."
                            />
                          <div className="col-12 col-sm-12">
                            <div className="form-check form-check-inline">
                              <input className="form-check-input" type="radio" id="male" name="sex" value='M' onChange={handleChange} checked={inputs.sex === "M"} required={true} disabled/>
                              <label className="form-check-label" htmlFor="male">Male</label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input className="form-check-input" type="radio" id="female" name="sex" value='F' onChange={handleChange} checked={inputs.sex === "F"} required={true} disabled/>
                              <label className="form-check-label" htmlFor="female">Female</label>
                            </div>
                          </div>  
                        </div>
                      </div>
                  </div>
               </div>
              <div className="row mt-4 col-12 col-sm-12">
                <div className="col-12 col-sm-6 order-1 pt-3">
                    <Link to="/membership/dashboard" state={{"contact_guid":location.state.contact_guid, "handicap_id": location.state.handicap_id}} className="w-100 btn btn-outline-secondary btn-lg rounded-pill px-5 " type="button">
                        BACK
                    </Link>
                   
                </div>
                <div className="col-12 col-sm-6 order-sm-1 order-lg-1 pt-3">
                    <button className="btn btn-primary w-100 btn-lg px-5 rounded-pill" type="submit">
                        UPDATE 
                    </button>
                </div>
            </div>
            </form> 
        </div>
        </div>
    )
}